import React, {Component} from 'react'
import FontAwesome from 'react-fontawesome'

class Loading extends Component {
  render() {
    let fa = (
      <FontAwesome
        name="cog"
        size="4x"
        spin
        style={{textShadow: '0 1px 0 rgba(0, 0, 0, 1.0)'}}
      />
    )
    return <div>{fa}</div>
  }
}

export default Loading



// WEBPACK FOOTER //
// ./src/components/Loading.jsx